import ua from 'ua'
export default ua.isMobile() ? 'tap' : 'click'



// WEBPACK FOOTER //
// ./src/mods/tapEvent.js